import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';


export default class ImageUploadField extends Component {
  static propTypes = {
    input: PropTypes.shape({
      name: PropTypes.string.isRequired,
      onChange: PropTypes.func.isRequired,
      value: PropTypes.any,
    }).isRequired,
    meta: PropTypes.shape({
      error: PropTypes.string,
      touched: PropTypes.bool.isRequired,
      warning: PropTypes.string,
    }).isRequired,
    label: PropTypes.string.isRequired,
  };

  render() {
    const {
      input: { name, value, onChange },
      meta: { touched, error, warning },
      label,
    } = this.props;

    return (
      <Card style={{ maxWidth: 300 }}>
        {touched && (error || warning) && <Typography variant="subtitle1">{error || warning}</Typography>}

        {value && (
          <img
            src={value}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 'calc(100% - 32px)',
              margin: 16,
              borderRadius: 16,
            }}
          />
        )}

        <CardActions>
          <div onClick={() => {
            const fileInput = findDOMNode(this.fileInput);

            fileInput.click();
          }}>
            <Button
              variant="contained"
              color="primary"
            >
              {value ? 'Wijzig foto' : 'Voeg foto toe...'}
            </Button>
          </div>

          <input
            type="file"
            ref={ref => { this.fileInput = ref; }}
            onChange={(event) => {
              event.preventDefault();

              let reader = new FileReader();
              let file = event.target.files[0];

              reader.onloadend = () => {
                onChange(reader.result);
              };

              reader.readAsDataURL(file);
            }}
            style={{
              display: 'none',
            }}
          />
        </CardActions>
      </Card>
    );
  };
};
